<div class="container">
  <div class="row center">
    <div class="col col-50 white">
      <app-spinner
        [display]="true"
        [class]="'spinner-container'"
        [messageToDisplay]="'Logging you in...'"
      ></app-spinner>
    </div>
  </div>
</div>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  @if (control.hasError(validation) && (control.dirty || control.touched)) {
    <div class="fv-plugins-message-container">
      <span role="alert">
        {{ message }}
      </span>
    </div>
  }
</ng-template>
